import {DAL, pointerUtils} from '@wix/document-manager-core'
import type {DataModelAPI} from '../../..'
import {MASTER_PAGE_ID, DATA_TYPES} from '../../../constants/constants'
import type {WidgetDescriptorDataItem, MasterPageDataItem, AppStudioDataItem} from '../types'
import {removePrefix} from '@wix/document-manager-utils'
const {getPointer} = pointerUtils

export class AppStudioRepository {
    private readonly masterPageData: MasterPageDataItem
    private readonly appStudioData: AppStudioDataItem
    private readonly widgetDescriptorByRootCompId: Record<string, WidgetDescriptorDataItem>

    // Find all master page information in constructor, since data is not changed due to the usage
    // And calculations could be cached, so we don't repeat search of the relevant data
    constructor(private readonly dal: DAL, dataModel: DataModelAPI) {
        this.masterPageData = this.dal.get(getPointer(MASTER_PAGE_ID, DATA_TYPES.data)) as MasterPageDataItem
        // AppStudio should always be present by default. But in case of
        // broken structure we throw an error
        if (!this.masterPageData.appStudioData) {
            throw new Error('AppStudio data is not found')
        }
        const appStudioDataItemId = removePrefix(this.masterPageData.appStudioData, '#')
        this.appStudioData = dataModel.getItem(
            appStudioDataItemId,
            DATA_TYPES.data,
            MASTER_PAGE_ID
        ) as AppStudioDataItem

        this.widgetDescriptorByRootCompId = this.appStudioData.widgets.reduce<Record<string, WidgetDescriptorDataItem>>(
            (acc, widgetDescriptorDataItem) => {
                const pageId = removePrefix(widgetDescriptorDataItem.rootCompId, '#')
                acc[pageId] = widgetDescriptorDataItem
                return acc
            },
            {}
        )
    }

    getAppStudioData() {
        return this.appStudioData
    }

    getMasterPageData() {
        return this.masterPageData
    }

    getWidgetDescriptorByPageId(pageId: string): WidgetDescriptorDataItem | undefined {
        return this.widgetDescriptorByRootCompId[pageId]
    }

    getWidgetsDescriptors() {
        return this.appStudioData.widgets
    }
}
